import React, {
  useEffect, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  Input,
  Button,
  Modal
} from 'antd';
import { useHistory } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';

import InfoView from 'components/common/InfoView';
import {
  fetchMerchantAccounts,
  addMerchantAccount,
  deleteMerchantAccount,
  updateMerchantAccount,
} from '../../redux/actions/Data';
import { getAllUsers } from '../../redux/actions/Auth';
import MerchantAccountForm from './MerchantForm';
import { merchantColumns } from '../../components/common/Columns';
import Can from '../../util/can';
import { MERCHANT_ACCOUNTS } from '../../constants/resources';
import generateQuery, { handleSearch as search } from '../../util/table';
import useForm from '../../hooks/useForm';

const MerchantAccounts = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { data: usersData, loading: loadingUser } = useSelector(({ auth }) => auth.users);

  const {
    addingMerchantAccount,
    data,
    loading,
    totalItems,
    pageSize,
    currentPage: current,
  } = useSelector(({ data }) => data.merchantAccounts);

  const [searchParams, setSearchParams] = useState('');
  const {
    form,
    onFormOk,
    formVisibility,
    handleShowModal,
    handleCancel,
    handleEditRecord,
    editableRecord,
  } = useForm();

  useEffect(() => {
    const pagination = `page=${current}&limit=${pageSize}`;
    dispatch(fetchMerchantAccounts(pagination));
    dispatch(getAllUsers('', false));
  }, [dispatch]);

  const handleDeleteMerchantAccount = (id) => {
    dispatch(deleteMerchantAccount(id));
  };

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(fetchMerchantAccounts(generateQuery(pagination, filters, sorter, searchParams)));
  };

  const handleSearch = (searchValue) => {
    const query = search(
      searchValue.trim().replace(/([^a-zA-Z0-9])/g, '\\$1'),
      dispatch, fetchMerchantAccounts, merchantColumns,
    );
    setSearchParams(query);
  };

  const navigateToMerchantView = (record) => {
    // dispatch(setSelectedMerchantAccount(record));
    history.push(`/merchant-accounts/${record._id}`);
  };

  const props = {
    loading,
    pagination: {
      current,
      pageSize,
      total: totalItems,
      showSizeChanger: false,
    },
    scroll: 'y',
    rowKey: '_id',
    columns: merchantColumns(
      handleDeleteMerchantAccount,
      handleEditRecord,
      navigateToMerchantView
    ),
    sticky: true,
    dataSource: !loading && !loadingUser && data
      ? data.map((item) => ({
        ...item,
        userDetail: {
          _id: item.user,
          name: item.userDetail?.name || usersData.find((element) => element._id === item.user)?.full_name
        },
      }))
      : [],
    onChange: handleOnChange,
  };

  const handleOk = (values) => {
    if (editableRecord._id) {
      dispatch(updateMerchantAccount(editableRecord._id, values));
    } else {
      dispatch(addMerchantAccount(values));
    }
  };

  return (
    (
      <div>
        <Can I="create" a={MERCHANT_ACCOUNTS}>
          <Button
            icon={<PlusOutlined />}
            type="primary"
            data-testid="add-merchantAccount-btn"
            onClick={() => handleShowModal()}
          >
            Add Business Account
          </Button>

        </Can>
        <div className="justify-content-center">
          <Input.Search
            data-testid="search-input"
            placeholder="Search business account"
            enterButton
            allowClear
            onSearch={handleSearch}
          />
        </div>
        <div className="gx-d-flex justify-content-center">
          <Table className="gx-table-responsive" {...props} />
        </div>
        <Modal
          title={editableRecord._id ? 'Edit Business Account' : 'Add Business Account'}
          open={formVisibility}
          okText={editableRecord._id ? 'Save' : 'Add'}
          onOk={() => onFormOk(handleOk)}
          confirmLoading={addingMerchantAccount}
          onCancel={handleCancel}
          width={1000}
        >
          <MerchantAccountForm {...{ form }} />
        </Modal>
        <InfoView />
      </div>
    )
  );
};

export default MerchantAccounts;
